import { Component, ViewEncapsulation, effect, inject } from '@angular/core';
import { TranslatePipe, TranslationService } from '../../../core/i18n';
import type { LocaleId } from '../../../core/i18n/locale-id';
import { ChatBotService } from '../../chatbot/chatbot.service';

/**
 * Floating support chat launcher for the native Omilia WebChatConfigurator.
 * The widget owns chat chrome, minimize/close, and the End Chat confirmation.
 */
@Component({
  selector: 'app-shell-support-chat',
  imports: [TranslatePipe],
  templateUrl: './shell-support-chat.html',
  styleUrl: './shell-support-chat.scss',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'app-shell__chat-host',
  },
})
export class ShellSupportChat {
  private readonly chatBot = inject(ChatBotService);
  private readonly translation = inject(TranslationService);
  private lastLocale: LocaleId | null = null;

  protected readonly isOpen = this.chatBot.isOpen;

  constructor() {
    effect(() => {
      const locale = this.translation.locale();
      if (this.lastLocale === null) {
        this.lastLocale = locale;
        return;
      }
      if (locale === this.lastLocale) {
        return;
      }
      this.lastLocale = locale;
      if (!this.chatBot.isSessionActive()) {
        this.chatBot.applyLocaleOnly(locale);
        return;
      }
      void this.chatBot.destroyAndRecreate(locale);
    });
  }

  /** Opens the native Omilia widget for the active UI locale. */
  protected onLauncherClick(): void {
    this.chatBot.openChat(this.translation.locale());
  }
}
